import {throwError as observableThrowError, Observable, of} from 'rxjs';
import {map, catchError} from 'rxjs/operators';
import {Injectable} from '@angular/core';
import {OutputStyleModel} from '../datamodel/output-style.datamodel';
import {CopyleaksCredits, SettingsModel} from '../datamodel/settings.datamodel';
import {environment} from '../../environments/environment';
import {CookieService} from 'web-common/src/app/cookie.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable()
export class SettingsService {
  constructor(
    private http: HttpClient,
    private cookieService: CookieService) {
  }

  public getOutputStyles(): Observable<OutputStyleModel> {
    return this.http.get('/biblio/outputstyles/').pipe(map(this.extractData),catchError(this.handleError),);
  }

  public saveSettings(settings: SettingsModel): Observable<any> {
    return this.http.put('/api/1/admin/settings/', settings).pipe(map(function (res: any) {
      return {status: 200, message: 'Institution settings have been updated.'};
    }),catchError(this.handleError),);
  }

  public getWayflessUrl(discountGroup: string): Observable<string> {

    let cookieString = 'id=' + this.cookieService.get('id') + '; user_token=' + this.cookieService.get('user_token') + ';';
    let headers = new HttpHeaders()
      .append('cookiestring', cookieString)
      .append('Content-Type', 'application/json')
      .append('apiVersion', '1')
      .append('appid', environment.appId);
    return this.http.get(environment.rw3apiURL + 'authentication/wayfless/' + discountGroup, {headers: headers}).pipe(
      //! figure out proper typing
      map(function (res: any) {
        return res.data;
      }),catchError(this.handleError),);
  }

  private extractData(res: any) {
    const body = res;
    if ((typeof body === 'object') && !!body) {
      return body as OutputStyleModel || {} as OutputStyleModel;
    } else {
      this.handleError('Attempted to retrieve output styles but failed');
    }
  }

  //! this function is EVERYWHERE. It should be exported
  public handleError = (error: any) => {
    // TODO: Use a remote logging infrastructure
    let errMsg: string;
    //! not sure if it works
    if (error.status) {
      const body = error || '';
      const err = body.error || JSON.stringify(body);
      errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }
    return observableThrowError(errMsg);
  }

  copyleaksPilotWasEnded(): Observable<boolean> {
    let url = environment.rw3apiURL + '/copyleaks/credit';
    const headers = new HttpHeaders({
      'cookieString': 'id=' + this.cookieService.get('id') + '; user_token=' + this.cookieService.get('user_token') + ';',
      'Content-Type': 'application/json; charset=UTF-8',
    });
    return this.http.get<CopyleaksCredits>(url, { headers }).pipe(
      map((res: any) => res.refWorksCreditsLeft <= 0),
      catchError(() => of(true))
    );
  }
}
